import styled from "@emotion/styled";
import { Typography } from "../Typography";
import { SubforestAvatar } from "./SubforestAvatar";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  line-height: 1.5em;
  margin: 0 auto;
  padding: 20px 8px;
`;

export const Details = styled(Typography)`
  color: ${(props) => props.theme.colors.night};
`;

const StyledLink = styled.a`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.night};
`;

type Props = {
  parentUsername: string;
  parentForestName: string;
  parentImageSrc: string;
};

export const SubforestInfo = (props: Props) => {
  return (
    <Container>
      <Details use="caption" as="h3">
        This forest is part of{" "}
        <StyledLink href={`/${props.parentUsername}`}>
          {props.parentForestName}
        </StyledLink>
      </Details>
      <StyledLink href={`/${props.parentUsername}`}>
        <SubforestAvatar
          alt={props.parentForestName}
          src={props.parentImageSrc}
        />
      </StyledLink>
    </Container>
  );
};
